<div class="form-subcontainer">
  <div class="form-content">
    <div>
      <form
        [formGroup]="formGroup"
        (ngSubmit)="submit()"
        class="fpx-form-group"
      >
        <section class="account-sec">
          <h3 class="fpx-sec-title account-lable">
            {{ "TRANSACTIONSEARCH.header" | translate }}
          </h3>
          <app-account-list
            formControlName="accountNumber"
            [disabled]="true"
          ></app-account-list>
        </section>
        <!-- <div class="filter-grp">
                        <img src="./assets/images/icons/search-filter.svg" alt="search">
                        <button type="button" class="btn show-filter" clickable (click)="handleFilter();">
                            Show Filter
                        </button>
                    </div> -->
        <section class="data-sec">
          <ng-container *ngIf="_commonService.isDesktop()">
            <h3 class="fpx-sec-title">
              {{ "TRANSACTIONSEARCH.filterLabel" | translate }}
            </h3>
          </ng-container>
          <div class="fpx-field">
            <app-trans-period
              label="{{ 'TRANSACTIONSEARCH.transactionPeriod' | translate }}"
              formControlName="transPeriod"
              [direction]="'row'"
            ></app-trans-period>
          </div>
          <ng-container *ngIf="state.transPeriod == '2'">
            <div class="date-range">
              <app-years formControlName="year" placeholder="Year"></app-years>
              <app-months
                depenencyControlName="year"
                [changePublisher]="formChangePublisher$"
                formControlName="month"
                placeholder="Month"
              ></app-months>
            </div>
          </ng-container>

          <ng-container *ngIf="state.transPeriod == '3'">
            <div class="fpx-field date-range">
              <app-from-date
                formControlName="fromDate"
                [minDate]="fromMinDate"
                label="{{'TRANSACTIONSEARCH.from'| translate}}"
                [placeholder]="state.placeholder"
              ></app-from-date>
              <app-to-date
                formControlName="toDate"
                label="{{ 'TRANSACTIONSEARCH.to' | translate }}"
                [minDate]="toMinDate"
                [maxDate]="toMaxDate"
                depenencyControlName="fromDate"
                [changePublisher]="formChangePublisher$"
                [placeholder]="state.placeholder"
              ></app-to-date>
            </div>
          </ng-container>

          <div class="fpx-field">
            <app-display-download
              label="{{ 'TRANSACTIONSEARCH.displayDownload' | translate }}"
              formControlName="displayDownload"
              [direction]="'row'"
            ></app-display-download>
          </div>
        </section>
        <section class="from-button-sec">
          <div class="search-btn-layer">
            <button
              class="button-common button40 active"
              type="submit"
              [disabled]="formGroup.invalid"
            >
              <span>{{ "FORM_ACTIONS.submit" | translate }}</span>
            </button>
          </div>
          <button
            class="btn-link button40 active"
            (click)="resetForm()"
            type="button"
          >
            <span>{{ "FORM_ACTIONS.reset" | translate }}</span>
          </button>
        </section>
      </form>
    </div>
    <div *ngIf="_trxSummary" class="transaction-list">
      <div class="search-result-header">
        {{ "TRANSACTIONSEARCH.searchResultHeader" | translate }}
      </div>
      <ng-container *ngFor="let item of _trxSummary; let i = index" clickable>
        <app-trx-list-detail
          [accountNumber]="item.accountNumber"
          [index]="i"
          [listDetail]="item"
          [selectedIndex]="selectedIndex"
        >
        </app-trx-list-detail>
      </ng-container>
    </div>
  </div>
</div>